import { Link } from "react-router-dom";
import type { Movie } from "@/mocks/movies";
import MovieCard from "@/components/feature/MovieCard";

interface HotSectionProps {
  hot: Movie[];
  topRated: Movie[];
}

export default function HotSection({ hot, topRated }: HotSectionProps) {
  return (
    <section className="bg-background-100/60">
      <div className="mx-auto max-w-[1400px] px-4 py-10 md:px-8 md:py-14">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1fr_320px]">
          <div>
            <div className="mb-6 flex items-end justify-between gap-4">
              <div>
                <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
                  <span className="h-5 w-1.5 rounded-full bg-accent-500 md:h-6"></span>
                  热门影视推荐
                </h2>
                <p className="mt-2 text-sm text-foreground-500">
                  根据播放与点击热度排序，大家都在看
                </p>
              </div>
              <Link
                to="/category/all?sort=hot"
                className="flex shrink-0 cursor-pointer items-center gap-1 whitespace-nowrap text-sm font-medium text-foreground-600 transition-colors hover:text-accent-500"
              >
                查看更多
                <i className="ri-arrow-right-s-line text-lg" aria-hidden="true"></i>
              </Link>
            </div>
            <div className="grid grid-cols-2 gap-3 md:grid-cols-3 md:gap-5">
              {hot.slice(0, 9).map((movie) => (
                <MovieCard key={movie.id} movie={movie} />
              ))}
            </div>
          </div>

          <aside className="h-fit rounded-lg border border-background-200/70 bg-background-50 p-5">
            <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
              <i className="ri-trophy-line text-accent-500" aria-hidden="true"></i>
              评分口碑榜
            </h2>
            <ul className="mt-4 space-y-2">
              {topRated.map((movie, index) => (
                <li key={movie.id}>
                  <Link
                    to={`/detail/${movie.id}`}
                    className="flex cursor-pointer items-center gap-3 rounded-md p-2 transition-colors hover:bg-background-100"
                  >
                    <span
                      className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-bold ${
                        index < 3
                          ? "bg-accent-500 text-background-50"
                          : "bg-background-200 text-foreground-700"
                      }`}
                    >
                      {index + 1}
                    </span>
                    <span className="truncate text-sm text-foreground-800">
                      {movie.title}
                    </span>
                    <span className="ml-auto shrink-0 text-sm font-semibold text-accent-500">
                      {movie.rating.toFixed(1)}
                    </span>
                  </Link>
                </li>
              ))}
            </ul>
          </aside>
        </div>
      </div>
    </section>
  );
}